import { ItemList } from '../../../objects/itemList'

export default (selectedList = 'default', lists: Array<ItemList>): ItemList => {
  const selected = lists.find(({ slug }) => slug === selectedList)
  if (selected !== undefined) {
    return selected
  } else {
    throw new Error('No default product list found')
  }
}
